import type { CSSProperties, ReactNode } from "react";
import { useInViewOnce } from "../motion/useInViewOnce";

/**
 * Le paraphe de la charte : un trait à l'encre sous le mot qui compte,
 * qui se dessine à l'apparition. Un seul par écran, réservé au site.
 */
export function Paraphe({
  children,
  delay = 500,
  tone = "light",
}: {
  children: ReactNode;
  delay?: number;
  /** Sur fond sombre, le violet d'action passe à sa version claire. */
  tone?: "light" | "onDark";
}) {
  const { ref, shown } = useInViewOnce<HTMLSpanElement>();
  const style = {
    "--draw-delay": `${delay}ms`,
    "--draw-duration": "1100ms",
  } as CSSProperties;
  return (
    <span
      ref={ref}
      data-shown={shown}
      className="relative inline-block whitespace-nowrap"
    >
      {children}
      <svg
        aria-hidden="true"
        viewBox="0 0 200 26"
        className={`pointer-events-none absolute -bottom-[0.3em] -left-[3%] w-[106%] overflow-visible ${
          tone === "onDark" ? "text-action-on-primary" : "text-action"
        }`}
      >
        <path
          className="enc-draw"
          pathLength={1}
          d="M4 17 C 44 8, 86 22, 128 13 S 180 5, 196 12 C 199 14, 196 18, 190 17"
          fill="none"
          stroke="currentColor"
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={style}
        />
      </svg>
    </span>
  );
}
